import React from 'react';
import {QueryHelpPageId} from './content/types';
import {QUERY_HELP_NAV_ITEMS} from './content/pages';

interface Props {
    activePage: QueryHelpPageId;
    onSelect: (page: QueryHelpPageId) => void;
}

const QUERY_HELP_NAV_ICONS: Record<QueryHelpPageId, React.ReactNode> = {
    simple: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 18h6" />
            <path d="M10 21h4" />
            <path d="M12 3a6 6 0 0 0-3.8 10.7c.5.4.8 1 .8 1.6V16h6v-.7c0-.6.3-1.2.8-1.6A6 6 0 0 0 12 3z" />
        </svg>
    ),
    syntax: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 8l-4 4 4 4" />
            <path d="M15 8l4 4-4 4" />
        </svg>
    ),
    samples: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="5" width="18" height="14" rx="2" />
            <path d="M7 10l2.5 2L7 14" />
            <line x1="12.5" y1="14" x2="16" y2="14" />
        </svg>
    ),
    complex: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="6" cy="12" r="2.5" />
            <circle cx="17" cy="6" r="2.5" />
            <circle cx="17" cy="18" r="2.5" />
            <line x1="8.2" y1="10.9" x2="14.8" y2="7.1" />
            <line x1="8.2" y1="13.1" x2="14.8" y2="16.9" />
        </svg>
    ),
    production: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 3l9 5-9 5-9-5 9-5z" />
            <path d="M3 12l9 5 9-5" />
            <path d="M3 16l9 5 9-5" />
        </svg>
    ),
    sales: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 17l6-6 4 4 7-7" />
            <path d="M17 7h4v4" />
        </svg>
    ),
};

const QueryHelpNav = React.memo<Props>(({activePage, onSelect}) => (
    <nav className="query-help-modal__nav" aria-label="Query help sections">
        <ul className="query-help-modal__nav-list">
            {QUERY_HELP_NAV_ITEMS.map((item) => (
                <li key={item.id}>
                    <button
                        type="button"
                        className={`query-help-modal__nav-item${activePage === item.id ? ' query-help-modal__nav-item--active' : ''}`}
                        onClick={() => onSelect(item.id)}
                    >
                        <span className="query-help-modal__nav-icon" aria-hidden="true">
                            {QUERY_HELP_NAV_ICONS[item.id]}
                        </span>
                        <span className="query-help-modal__nav-copy">
                            <span className="query-help-modal__nav-label">{item.label}</span>
                            <span className="query-help-modal__nav-description">{item.description}</span>
                        </span>
                    </button>
                </li>
            ))}
        </ul>
    </nav>
));

export default QueryHelpNav;
